import React from "react";
import { MapPin, Navigation } from "lucide-react";

const VILLES = [
  "Perpignan", "Cabestany", "Saint-Estève", "Canet-en-Roussillon",
  "Bompas", "Pia", "Rivesaltes", "Saleilles", "Toulouges", "Le Soler",
  "Argelès-sur-Mer", "Thuir", "Elne", "Saint-Cyprien",
];

export const Zone = () => {
  return (
    <section id="zone" className="relative py-24 sm:py-32 bg-[#0A0A0A]" data-testid="zone-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
              — Zone d'intervention
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
              Perpignan<br />
              <span className="text-[#FFD600]">& alentours.</span>
            </h2>
            <p className="mt-5 text-neutral-400 text-lg leading-relaxed max-w-xl">
              Basé au <strong className="text-white">2670 avenue Julien Panchot, 66000 Perpignan</strong>,
              j'interviens dans toute l'agglomération et les communes environnantes des Pyrénées-Orientales.
              Pour les longues distances, contactez-moi pour un devis.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {VILLES.map((v) => (
                <span
                  key={v}
                  data-testid={`ville-tag-${v.toLowerCase().replace(/\s/g, "-")}`}
                  className="inline-flex items-center gap-1.5 bg-[#171717] border border-[#262626] hover:border-[#FFD600]/50 text-neutral-300 px-3 py-1.5 rounded-full text-xs font-medium transition-colors"
                >
                  <MapPin className="w-3 h-3 text-[#FFD600]" />
                  {v}
                </span>
              ))}
              <span className="inline-flex items-center gap-1.5 bg-[#FFD600]/10 border border-[#FFD600]/30 text-[#FFD600] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider">
                + autres sur demande
              </span>
            </div>

            <a
              href="https://www.google.com/maps/dir/?api=1&destination=2670+avenue+Julien+Panchot+66000+Perpignan"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="open-maps-button"
              className="mt-8 inline-flex items-center gap-2 text-[#FFD600] hover:text-white font-semibold uppercase tracking-wider text-sm transition-colors"
            >
              <Navigation className="w-4 h-4" strokeWidth={2.5} />
              Itinéraire vers MK Remorquage
            </a>
          </div>

          <div className="relative aspect-[4/5] rounded-lg overflow-hidden border border-[#262626]">
            <iframe
              title="Carte MK Remorquage Perpignan"
              src="https://www.google.com/maps?q=2670+avenue+Julien+Panchot+66000+Perpignan&output=embed"
              className="absolute inset-0 w-full h-full grayscale-[40%] contrast-110"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="zone-map"
            />
            <div className="absolute top-4 left-4 bg-[#0A0A0A]/95 border border-[#FFD600]/40 px-4 py-3 rounded-md max-w-[260px] backdrop-blur-md">
              <div className="text-[#FFD600] text-[10px] font-bold uppercase tracking-[0.25em] mb-1">
                Adresse
              </div>
              <div className="text-white text-sm font-semibold leading-snug">
                2670 avenue Julien Panchot<br />
                66000 Perpignan
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Zone;
